module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step2_Image14.0589ee19.jpg";